export default "__VITE_ASSET__xXwMSyJM__"